import { User } from '@supabase/supabase-js';
import { routeInfo } from '@/lib/_utils/routing.ts';
import useTranslation from 'next-translate/useTranslation';
import { usePathname, useRouter } from 'next/navigation';
import Link from 'next/link';
import Image from 'next/image';
import logo from '@public/components/layout/header/logo.svg';
import logoBack from '@public/components/layout/header/logo-back.svg';
import logoMobile from '@public/components/layout/header/logo-mobile.svg';
import { BOTTOM_NAV_ALLOWED_ROUTES } from '@/lib/_utils/index.tsx';

interface HeaderLogoProps {
	user?: User | null;
}

export const HeaderLogo = ({ user }: HeaderLogoProps) => {
	const { t } = useTranslation();
	const routerPathname = usePathname();
	const router = useRouter();
	const logoRedirectLink = routeInfo({ t, page: 'dashboard' }).path;
	const shouldShowBackButton = user && !BOTTOM_NAV_ALLOWED_ROUTES.includes(routerPathname);

	return (
		<div>
			<Link href={logoRedirectLink} className='lg:hidden'>
				<Image src={logo} width={103} height={24} priority alt='Tralent' />
			</Link>
			<div className={`hidden lg:flex`}>
				{shouldShowBackButton ? (
					<button type={'button'} onClick={() => router.back()}>
						<Image src={logoBack} width={32} height={32} priority alt='Tralent' />
					</button>
				) : (
					<Link href={logoRedirectLink}>
						<Image src={logoMobile} width={32} height={32} priority alt='Tralent' />
					</Link>
				)}
			</div>
		</div>
	);
};
